import i18n from 'utils/i18n'
import { WidgetDateFilter } from './types'

const toFixedTruncate = (num: number, decimalPlaces: number) => {
  const factor = Math.pow(10, decimalPlaces)
  return Math.floor(num * factor) / factor
}

export const getShortNumber = (number: number) => {
  if (number >= 10_000_000) {
    return toFixedTruncate(number / 1_000_000, 1) + 'mil'
  }
  if (number >= 1_000_000) {
    return toFixedTruncate(number / 1_000_000, 2) + 'mil'
  }
  if (number >= 100_000) {
    return toFixedTruncate(number / 1000, 0) + 'k'
  }
  if (number >= 10_000) {
    return toFixedTruncate(number / 1000, 1) + 'k'
  }
  return toFixedTruncate(number, 0)
}

export const getDateFilter = (
  period: WidgetDateFilter,
): {
  startDate: string
  endDate: string
} => {
  switch (period) {
    case '1d':
    default:
      return {
        startDate: new Date().toISOString().split('T')[0],
        endDate: new Date(new Date().setDate(new Date().getDate() - 1)).toISOString().split('T')[0],
      }
    case '1w':
      return {
        startDate: new Date().toISOString().split('T')[0],
        endDate: new Date(new Date().setDate(new Date().getDate() - 7)).toISOString().split('T')[0],
      }
    case '1m':
      return {
        startDate: new Date().toISOString().split('T')[0],
        endDate: new Date(new Date().setMonth(new Date().getMonth() - 1))
          .toISOString()
          .split('T')[0],
      }
    case '3m':
      return {
        startDate: new Date().toISOString().split('T')[0],
        endDate: new Date(new Date().setMonth(new Date().getMonth() - 3))
          .toISOString()
          .split('T')[0],
      }
    case '6m':
      return {
        startDate: new Date().toISOString().split('T')[0],
        endDate: new Date(new Date().setMonth(new Date().getMonth() - 6))
          .toISOString()
          .split('T')[0],
      }
    case '1y':
      return {
        startDate: new Date().toISOString().split('T')[0],
        endDate: new Date(new Date().setFullYear(new Date().getFullYear() - 1))
          .toISOString()
          .split('T')[0],
      }
  }
}

export const getDateFilterVersusText = (period: WidgetDateFilter): string => {
  const t = (key: string) => i18n.t(`pages.widgets.vs_dates.${key}`)
  switch (period) {
    case '1d':
    default:
      return t('yesterday')
    case '1w':
      return t('last_week')
    case '1m':
      return t('last_month')
    case '3m':
      return t('last_3_months')
    case '6m':
      return t('last_6_months')
    case '1y':
      return t('last_year')
  }
}
